/**
 * @file 全局组件注册
 */
import Vue from 'vue'
import Icon from 'vue-svg-icon/Icon.vue'
import Pager from 'library/components/Pager'
import Empty from 'library/components/Empty'
import ContainerTitle from 'library/components/ContainerTitle'
import commonFilter from '@/common/components/commonFilter'
import commonTable from '@/common/components/commonTable'
import CommonCard from '@/common/components/commonCard'

/**
 * 注册全局组件
 */
export function setupComponents() {
    Vue.component('icon', Icon)
    Vue.component('Pager', Pager)
    Vue.component('Empty', Empty)
    Vue.component('ContainerTitle', ContainerTitle)
    Vue.component('commonFilter', commonFilter)
    Vue.component('commonTable', commonTable)
    Vue.component('CommonCard', CommonCard)
}

